module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/head-dec-1-329b1fb3e41109abf78b095082ec6cd6.png";